<div [class.container-fluid]="!embedded" [class.main-card]="!embedded">
    <div class="row align-items-center mb-3 hide-mobile" *ngIf="!embedded">
        <div class="col-lg-8 col-12">
            <h1>
                Carte de mes favoris
                <span>Visualisez tous vos favoris sur une carte</span>
            </h1>
        </div>
        <div class="col-lg-4 col-12 text-lg-end">
            <a class="btn btn-outline" [routerLink]="backLink">
                <i class="fa fa-arrow-left"></i>
                Retour aux favoris
            </a>
        </div>
    </div>

    <!-- Onglets Liste / Carte (mobile) : uniquement en mode autonome (la vue Liste porte le switch) -->
    <div class="tabs tabs_full fav-view-tabs visible-mobile" *ngIf="!embedded">
        <a class="tab" routerLinkActive="active" [routerLink]="backLink">Liste</a>
        <a class="tab" routerLinkActive="active"
           [routerLink]="['/app/favorites/map']"
           [queryParams]="{from: fromList}">Carte</a>
    </div>

    <div class="row" *ngIf="loading">
        <div class="col-12 text-center p-5">
            <mat-spinner diameter="50" class="mx-auto"></mat-spinner>
        </div>
    </div>

    <div class="row" *ngIf="!loading && items.length === 0">
        <div class="col-12">
            <div class="card">
                <div class="card-body text-center p-5">
                    <i class="fa fa-map-o fa-3x text-muted mb-3"></i>
                    <h2>Aucun favori à afficher</h2>
                    <p>Ajoutez des favoris pour les visualiser sur la carte.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-3" *ngIf="!embedded && !loading && listColors.length > 0">
        <div class="col-12 fav-map-filters">
            <button type="button"
                    class="filter-chip"
                    [class.active]="hiddenLists.size > 0"
                    [matMenuTriggerFor]="listsMenu"
                    #listsTrigger="matMenuTrigger"
                    (click)="closeAllFilterMenus(listsTrigger)">
                Favoris : {{ getListsFilterLabel() }}
                <i class="fa fa-chevron-down ms-2"></i>
            </button>
            <mat-menu #listsMenu="matMenu" [hasBackdrop]="false" (opened)="onFilterMenuOpened(listsTrigger)">
                <div class="filter-popup filter-popup-check" (click)="$event.stopPropagation()">
                    <div *ngFor="let l of listColors" class="filter-check-item">
                        <mat-checkbox [checked]="!isHidden(l.id)"
                                      (change)="toggleList(l.id)">
                            <span class="fav-map-legend-dot" [style.background]="l.color"></span>
                            {{ l.name }}
                        </mat-checkbox>
                    </div>
                    <div class="filter-check-actions" *ngIf="hiddenLists.size > 0">
                        <button type="button" class="filter-check-clear" (click)="showAllLists()">
                            Tout afficher
                        </button>
                    </div>
                    <div class="filter-check-actions" *ngIf="hiddenLists.size === 0 && listColors.length > 0">
                        <button type="button" class="filter-check-clear" (click)="hideAllLists()">
                            Tout effacer
                        </button>
                    </div>
                </div>
            </mat-menu>

            <button type="button"
                    class="filter-chip"
                    [class.active]="selectedStatuses.size > 0 && selectedStatuses.size < availableStatuses.length"
                    [matMenuTriggerFor]="statusMenu"
                    #statusTrigger="matMenuTrigger"
                    (click)="closeAllFilterMenus(statusTrigger)">
                Statut : {{ getStatusFilterLabel() }}
                <i class="fa fa-chevron-down ms-2"></i>
            </button>
            <mat-menu #statusMenu="matMenu" [hasBackdrop]="false" (opened)="onFilterMenuOpened(statusTrigger)">
                <div class="filter-popup filter-popup-check" (click)="$event.stopPropagation()">
                    <div *ngFor="let s of availableStatuses"
                         class="filter-check-item"
                         [class.is-muted]="getStatusCount(s) === 0">
                        <mat-checkbox [checked]="isStatusSelected(s)"
                                      (change)="toggleStatus(s)">
                            {{ commonService.getStatusLib(s) }}
                            <span class="filter-check-count">({{ getStatusCount(s) }})</span>
                        </mat-checkbox>
                    </div>
                    <div class="filter-check-actions" *ngIf="selectedStatuses.size > 0">
                        <button type="button" class="filter-check-clear" (click)="clearStatusFilter()">
                            Effacer
                        </button>
                    </div>
                </div>
            </mat-menu>
        </div>
    </div>

    <div class="row" *ngIf="!loading && items.length > 0">
        <div class="col-12">
            <div class="card" [class.map-embedded]="embedded">
                <div class="card-body p-0">
                    <div class="map-container"></div>
                </div>
            </div>
        </div>
    </div>
</div>
